'use client'

import React, { FC, ReactElement } from 'react'
import styles from './Address.module.css'
import Wallet from '@/utils/wallet'
import classNames from 'classnames'

const Address: FC<{ value?: string; className?: string; showCharacterCount?: number }> = (
	props
): ReactElement => {
	const address = props.value || Wallet.getTaprootAddress()
	const leadingCharacters = address.slice(0, props.showCharacterCount)
	const trailingCharacters = address.slice(-(props as any).showCharacterCount)

	if ((props.value && !props.showCharacterCount) || props?.value?.includes('.')) {
		return (
			<div className={classNames(styles.root, { [(props.className as any)]: !!props.className })}>
				{props.value}
			</div>
		)
	}

	return (
		<div className={classNames(styles.root, { [(props.className as any)]: !!props.className })}>
			{props.showCharacterCount ? `${leadingCharacters}...${trailingCharacters}` : address}
		</div>
	)
}

export default Address
